module.exports = __webpack_public_path__ + "img/outdoor.74c62f49.jpg";